import React,{ useState, useEffect, useContext, useCallback } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import ReactLoading from 'react-loading';
import InputAdornment from '@material-ui/core/InputAdornment';

import Checkbox from '@material-ui/core/Checkbox';

import { SessionContext } from "../context/session-context";
import { UserContext } from "../context/user-context";

import defaultPrintScale from "../functions/getPrintDefaultScale";
import acceptPrintScale from "../functions/acceptPrintScale";
import getPrice from "../functions/getPrintPrice";
import setPrintGrid from "../functions/getPrintGridSize";
import setPrintMapLayers from "../functions/setPrintMapLayers";
import recordPrintOrder from "../functions/recordPrintOrder";
import downloadOrder from "../functions/downloadOrder";
import downloadSample from "../functions/downloadSample";
import creditCheck from "../functions/doCreditCheck";

import GetAppIcon from '@material-ui/icons/GetApp';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

export default function PrintPanel(props) {

  const useStyles = makeStyles((theme) => ({
    root: {
      width: props.width,
      minWidth: props.width,
      height: props.height - 30,
      overflowY: "auto",

      '& .MuiOutlinedInput-root':{
        height:30
      },
      '& .MuiAccordion-root:before':{
        top: 0
      },
      '& .MuiAccordion-root.Mui-expanded':{
        margin: 0
      },
      '& .MuiAccordionSummary-root':{
        color:'#fff',
        background:'#0C4C35',
        borderBottom: '1px solid #209A39'
      },
      '& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 30,
        borderBottom: '0px solid #3D3E4F',
      },
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: 10
      },
      '& .MuiCheckbox-root': {
        paddingTop: 0,
        paddingBottom: 5,
        paddingRight: 5,
        paddingLeft: 0,
      },
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: '#63D764',
        paddingTop: 0,
        paddingBottom: 5,
        paddingRight: 5,
        paddingLeft: 0,
      },
      '& a': {
        color: '#0C4C35',
      },
      '& #panel1a-content': {
        marginTop: 10,
      }
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    container: {
      maxWidth: 360,
    },
    textField: {
      minWidth: 200,
      paddingRight:5,
      marginBottom:10,
    },
    printDescription:{

    },
    textItemFont:{
      fontSize:11
    },
    priceLabel: {
      paddingBottom:5,
    },
    textgridField:{
      paddingTop:2,
    },
    priceTable:{
      paddingTop:10,
      paddingBottom:10,
    },
    purchaseButton:{
      width:'50%',
      height: 20,
      color: '#FFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    cancelButton:{
      width: '35%',
      height: 20,
      color: '#FFF',
      marginLeft: 10,
      backgroundColor: '#666',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    downloadButton:{
      width: 160,
      height: 40,
      color: '#FFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    closeMenuButton:{
      width: 60,
      height: 40,
      color: '#FFF',
      marginLeft: 10,
      backgroundColor: '#0C4C35',
      '&:hover': {
        backgroundColor: '#63D764'
      },
    },
    errorTxt:{
      color: '#cc0000',
      paddingBottom:5,
    },
    printAreaLabel:{
      paddingTop:2,
      paddingLeft:35
    }
  }));

  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [uState] = useContext(UserContext);

  const [vatRate, setVatRate] = useState(parseFloat(process.env.REACT_APP_VAT_RATE));
  const [hasTemplate, setHasTemplate] = useState(true);

  const [displayFrame, setDisplayFrame] = useState(false);
  const [printlayer, setPrintlayer] = useState(sState.blayer);
  const [expanded, setExpanded] = useState('panel1');
  const [papersize, setPapersize] = useState('');//'a4_medium'
  const [papersizeitems, setPapersizeitems] = useState([]);
  const [scale, setScale] = useState('');
  const [scaleitems, setScaleitems] = useState([]);
  const [outputitems, setOutputitems] = useState([]);
  const [layoutitems, setLayoutitems] = useState([]);
  const [customscale, setCustomscale] = useState('');
  const [hasCustomScale, setHasCustomScale] = useState(false);
  const [format, setFormat] = useState('pdf');
  const [orientation, setOrientation] = useState('portrait');
  const [hasgrid, setHasgrid] = useState(false);

  const [price, setPrice] = useState(0);
  const [vat, setVAT] = useState(0);
  const [total, setTotal] = useState(0);

  //const [getprice, setGetprice] = useState(false);
  const [lockPurchase, setLockPurchase] = useState(true);
  const [sampleProduct, setSampleProduct] = useState('');

  const [hasScaleError, setHasScaleError] = useState(false);
  const [scaleErrorText, setScaleErrorText] = useState('');
  const [hasReview, setHasReview] = useState(false);
  const [downloaddisabled, setDownloaddisabled] = useState(true);

  const [hasPrint, setHasPrint] = useState(true);
  const [hasCheckout, setHasCheckout] = useState(true);
  const [hasDownload, setHasDownload] = useState(false);

  const [orderID, setOrderID] = useState(0);
  const [isProcess, setIsProcess] = useState(true);
  const [orderStatus, setOrderStatus] = useState('');
  const [doPoll, setDoPoll] = useState(false);
  const [pollTimer, setPollTimer] = useState(null);
  const [printArea, setPrintArea] = useState(0);

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [projectReference, setProjectReference] = useState(sState.projectreference);
  const [hasPRError, setHasPRError] = useState(false);
  const [poNumber, setPoNumber] = useState(sState.userreference);
  const [hasPriceError, setHasPriceError] = useState(false);
  const [hasPriceErrorMsg, setHasPriceErrorMsg] = useState('');
  const [hasDownloadError, sethasDownloadError] = useState(false);

  const [purchaseTooltip, setPurchaseTooltip] = useState('Select to purchase your print.');

  const allowedPattern = /^[a-zA-Z0-9_#$@%&-/(), ]*$/;

  /** Set the options based on baselayer. One time only */
  useEffect(() => {
    configurePrintOptions(sState.blayer, uState.company.companytype);
    setLockPurchase(true);
    if (uState.company.companytype == 'training') { setPurchaseTooltip('Select to download a sample print.') };
  },[]);

  useEffect(() => {
    configurePrintOptions(printlayer, uState.company.companytype);
  },[printlayer]);


  const configurePrintOptions = (value, companytype) => {
    let page_default  = [{ value: 'a4', label: 'A4' },{ value: 'a3', label: 'A3' },{ value: 'a2', label: 'A2' },{ value: 'a1', label: 'A1' },{ value: 'a0', label: 'A0' }];
    let page_reduce = []
    let scaleOptions = []
    let outputOptions = []
    let layoutOptions = []

    switch (companytype){
      case 'agent':
        page_reduce = [{ value: 'a5_image', label: 'Map Image' }];
        scaleOptions = [{ value: '200', label: '1:200' },{ value: '350', label: '1:350' },{ value: '500', label: '1:500' },{ value: '1250', label: '1:1250' },{ value: '2500', label: '1:2500' },{ value: 'custom', label: 'Custom' }];
        outputOptions = [{ value: 'jpg', label: 'JPG'}];
        layoutOptions = [{ value: 'landscape', label: 'Landscape'}];
        setPapersize('a5_image');
        setFormat('jpg');
        setOrientation('landscape');
      break;
      case 'consultancy':
        page_reduce = [{ value: 'a4_small', label: 'A4 Small' },{ value: 'a4_medium', label: 'A4 Standard' },{ value: 'a4_planningmap', label: 'A4 Planning Map' },{ value: 'a4_radon', label: 'A4 Radon Template' },{ value: 'a3', label: 'A3' }];
        scaleOptions = [{ value: '200', label: '1:200' },{ value: '500', label: '1:500' },{ value: '1250', label: '1:1250' },{ value: '2500', label: '1:2500' },{ value: '10000', label: '1:10,000' },{ value: 'custom', label: 'Custom' }];
        outputOptions = [{ value: 'pdf', label: 'PDF' },{ value: 'jpg', label: 'JPG'}];
        layoutOptions = [{ value: 'portrait', label: 'Portrait' },{ value: 'landscape', label: 'Landscape'}];
        setPapersize('a4_medium');
        break;
      default:
        page_reduce = [{ value: 'a4_small', label: 'A4 Small' },{ value: 'a4_medium', label: 'A4 Standard' },{ value: 'a4_planningmap', label: 'A4 Planning Map' },{ value: 'a3', label: 'A3' }];
        scaleOptions = [{ value: '200', label: '1:200' },{ value: '500', label: '1:500' },{ value: '1250', label: '1:1250' },{ value: '2500', label: '1:2500' },{ value: 'custom', label: 'Custom' }];
        outputOptions = [{ value: 'pdf', label: 'PDF' },{ value: 'jpg', label: 'JPG'}];
        layoutOptions = [{ value: 'portrait', label: 'Portrait' },{ value: 'landscape', label: 'Landscape'}];
        setPapersize('a4_medium');
        break;
    }

    switch(value){
      case "osvml":
        scaleOptions = [{ value: '1250', label: '1:1250' },{ value: '2500', label: '1:2,500' },{ value: '5000', label: '1:5,000' },{ value: '10000', label: '1:10,000' },{ value: 'custom', label: 'Custom' }];
        break;
      case "os10k":
        scaleOptions = [{ value: '5000', label: '1:5,000' },{ value: '10000', label: '1:10,000' },{ value: 'custom', label: 'Custom' }];
        break;
      case "os25k":
        scaleOptions = [{ value: '10000', label: '1:10,000'  },{ value: '25000', label: '1:25,000' },{ value: '50000', label: '1:50,000' }];
        break;
      case "os50k":
        scaleOptions = [{ value: '25000', label: '1:25,000'  },{ value: '50000', label: '1:50,000' },{ value: '100000', label: '1:100,000' }];
        break;
      case "os250k":
        scaleOptions = [{ value: '250000', label: '1:250,000'  },{ value: '500000', label: '1:500,000' },{ value: '1000000', label: '1:1,000,000' }];
        break;
    }
    setPapersizeitems(page_reduce);
    setScaleitems(scaleOptions);
    setOutputitems(outputOptions);
    setLayoutitems(layoutOptions);

    if (scale === '') { setScale(defaultPrintScale(sState.blayer)) }

    let scaleFound = false;
    scaleOptions.forEach(function(s){
      if (scale === s.value){
        scaleFound = true;
      }
    })
    if (!scaleFound){
      setScale(defaultPrintScale(value));
    }

    if (!displayFrame) { setDisplayFrame(true); }
  };

  /**
   * State to handle if the print frame should be displayed on the map window.
   */
  useEffect(() => {
    if (displayFrame !== sState.hasPrintFrame){
      sDispatch({
        type: "displayPrintFrame",
        payload: { hasPrintFrame: displayFrame}
      });
    }
  },[displayFrame]);

  /**
   * On change of print template
   */

  useEffect(() => {
    if (printlayer !== null && papersize !== null && scale !== null && orientation !== null){
      setLockPurchase(true);
      handleTemplateChange();
    }
  },[printlayer, papersize, scale, orientation]);

  var template_edit_timer;
  const handleTemplateChange = () => {

    window.clearTimeout(template_edit_timer);
    template_edit_timer = window.setTimeout(function(){

      const p = sState.print;
      p.layer = printlayer;
      p.size = papersize;
      p.scale = scale;
      p.orientation = orientation;

      sDispatch({
        type: "setprint",
        payload: { print: p}
      });

      sDispatch({
        type: "getprice",
        payload: { getPrice: true}
      });
      sDispatch({ type: "setUserAction", payload: { action: "getPrintPrice" } });
    }, 1500);

  };


  useEffect(() => {

    handleTemplateSettingChange();

  },[title, description, format, hasgrid]);


  var template_setting_timer;
  const handleTemplateSettingChange = () => {

    window.clearTimeout(template_setting_timer);
    template_setting_timer = window.setTimeout(function(){

      const p = sState.print;
      p.title = title;
      p.description = description;
      p.format = format;
      p.gridlines = hasgrid;

      sDispatch({
        type: "setprint",
        payload: { print: p}
      });
    }, 1500);
  };

  /**
   * Populate the print price
   */
  useEffect(() => {

    if (typeof sState.orderPrice.price !== 'undefined'){

      if (sState.caction === 'getPrintPrice' && parseFloat(sState.orderPrice.price).toFixed(2) !== price){

        switch(parseFloat(sState.orderPrice.price).toFixed(2)){
          case -500:
            setHasPriceError(true);
            setHasPriceErrorMsg('Invalid print area provided.')
            setLockPurchase(true);
            break;
          default:
            setHasPriceError(false);
            const pprice = parseFloat(sState.orderPrice.price).toFixed(2);
            const vprice = parseFloat(parseFloat(pprice/100) * parseFloat(vatRate)).toFixed(2);
            const tprice = parseFloat(parseFloat(pprice) + parseFloat(vprice)).toFixed(2);

            setPrice(pprice);
            setVAT(vprice);
            setTotal(tprice);
            setLockPurchase(false);
            break;

        }
      }
    }
  },[sState.orderPrice, sState.caction]);


  useEffect(() => {

    if (!sState.getPrice){
      setLockPurchase(false);
    }
  },[sState.getPrice]);

  /**
   * Handles the update of project reference and PO.
   */
  useEffect(() => {
    sDispatch({ type: "setreference", payload: { projectreference: projectReference, userreference:poNumber} });
  },[projectReference, poNumber]);


  /**
   * Gets the price when the print frame has changed.
   */
  useEffect(() => {
    getPrice(sState, sDispatch, uState.company.pricingid);
    const printframearea = sState.printArea;

    //Get print frame area:
    switch(printlayer){
      case "osmmbw":
      case "osmm":
        const areacalc_ha = (printframearea * 0.0001)+0.005;
        setPrintArea(parseFloat(areacalc_ha).toFixed(2).toString()+"Ha");
        break;
      default:
        const areacalc_km = (printframearea * 0.0001)+0.005;
        setPrintArea(parseFloat(areacalc_km).toFixed(2).toString()+"Km2");
        break;

    }
  },[sState.printframeextent]);


  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleScaleChange = (v) => {
    if (v === 'custom'){ setHasCustomScale(true); setCustomscale(parseInt(defaultPrintScale(printlayer))); } else { setHasCustomScale(false);  }
    setScale(v);
  }

  var scaletimer;
  const handleCustomScaleChange = (event) => {
    setLockPurchase(true);
    const re = /^[0-9\b]+$/;
    let cscale = 0;
    if (re.test(event.target.value)) {
      setCustomscale(parseInt(event.target.value));
      cscale = parseInt(event.target.value);
    }

    window.clearTimeout(scaletimer);
    scaletimer = window.setTimeout(function(){
      const okscales = acceptPrintScale(sState.print.layer);
      if (cscale >= okscales.min && cscale <= okscales.max){
        setHasScaleError(false);

        const p = {
          layer: printlayer,
          size: papersize,
          scale: cscale,
          orientation : orientation,
          format: format,
          gridlines: hasgrid,
        }

        sDispatch({
          type: "setprint",
          payload: { print: p}
        });
        sDispatch({
          type: "getprice",
          payload: { getPrice: true}
        });
      } else {
        setHasScaleError(true);
        setScaleErrorText('Scale must be between '+okscales.min+' and '+okscales.max);
      }
    }, 2000);
  }

  /**
   * Handles the order of the print.
   */
  const handlePurchase = async () => {
    let hasError = false;
    sethasDownloadError(false);
    
    if (projectReference.length <= 1 ){
      setHasPRError(true);
      hasError = true;
    } else {
      setHasPRError(false);
    }

    if (isNaN(price) || isNaN(vat)){
      setHasPriceError(true);
      setHasPriceErrorMsg('Pricing error detected!, Please reset settings')
      hasError = true;
    } else {
      setHasPriceError(false);
    }

    const hasEnoughCredit = await creditCheck(sState.userid, uState.company.companycreditlimit, price, sDispatch);

    if (!hasError && hasEnoughCredit) {

      setHasDownload(true);
      setDownloaddisabled(false);
      setHasPrint(false);
      setHasCheckout(false);
      setIsProcess(true);
      setLockPurchase(true);
      

      const template = preparePlotRequest();

      const printPrice = {};
      printPrice.price = price;
      printPrice.vat = vat;
      printPrice.total = total;
      //Stores the order transaction.

      let date = new Date();
      date.setMonth(date.getMonth() + 12);
      const day= ('0'+date.getDate()).slice(-2);
      const month = ('0'+(date.getMonth()+ 1)).slice(-2);
      const expiryDate = date.getFullYear()+'-'+ month +'-'+day;


      if (uState.company.companytype == 'training') {

        setSampleProduct("print_"+printlayer);
        setDownloaddisabled(false);
        setIsProcess(false);
      } else {
        recordPrintOrder(sState, printPrice, 'ordered','12months', expiryDate, template, sDispatch);
      }
      

      //Clear screen
      sDispatch({ type: "setUserAction", payload: { action: "clearPrint" } });
    }

  };

  /**
   * Handles the order of the print.
   */
  const cancelPurchase = () => {
    //Clear screen
    sDispatch({ type: "setUserAction", payload: { action: "endprint" } });
  };


  /**
   * Prepares the print request.
   */
  const preparePlotRequest= () => {
    const templates = sState.templates;
    let bFound = false;
    let template ={};

    templates.forEach(function (t) {
      if (t.pagesize === sState.print.size && t.orientation === sState.print.orientation){
        template = JSON.parse(JSON.stringify(t.ptemplate.items[0]));
        bFound = true;
      }
    });
    if (bFound){
      template.templatePage.type = sState.print.format.toLowerCase();

      let mapFormat;

      switch(printlayer){
        case "osmm":
        case "osmmbw":
          mapFormat = "image/svg";
          break;
        default:
        case "os10k":
        case "osvml":
        case "os25k":
        case "os50k":
        case "os250k":
        case "aerial":
          mapFormat = "image/jpeg";
          break;
      }


      const ext = sState.printframeextent;
      for(let i in template.templatePage.items){
        switch(Object.keys(template.templatePage.items[i]).toString()){
          case "map":
            template.templatePage.items[i].map.basePath = process.env.REACT_APP_WMS_PRINT;
            template.templatePage.items[i].map.showGrid = Boolean(sState.print.gridlines);
            template.templatePage.items[i].map.mapScale = parseInt(sState.print.scale);
            template.templatePage.items[i].map.service = "WMS";
            template.templatePage.items[i].map.version = "1.1.1";
            template.templatePage.items[i].map.request = "GetMap";
            template.templatePage.items[i].map.format = mapFormat;
            template.templatePage.items[i].map.layers = setPrintMapLayers(printlayer, sState.dlayer, sState.dlayerList, uState.company.companytype);
            template.templatePage.items[i].map.srs = "EPSG:27700";
            template.templatePage.items[i].map.bbox = ext[0]+","+ext[1]+","+ext[2]+","+ext[3];
            template.templatePage.items[i].map.annotations = [];
            template.templatePage.items[i].map.transparent = true;

            //Gets and sets the grid.
            template.templatePage.items[i].map.grid = setPrintGrid(sState.print.scale);

            //Add Map annotations
            if (sState.mapAnnotations.length > 0){
              const mapMarkups = [];
              let annoLength = parseInt(sState.mapAnnotations.length);
              for(let i = 0 ; i < annoLength; i++) {
                let a = {};
                let m = sState.mapAnnotations[i];

                if (m.type === 'polygon'){

                  let pDetails = {};
                  pDetails.showLine = true;
                  let lineStyle = rgbStringConvert(m.stroke.color_);
                  pDetails.fillOpacity = 0
                  pDetails.lineWidth = parseFloat(m.stroke.width_);
                  pDetails.lineRed = lineStyle.r;
                  pDetails.lineGreen = lineStyle.g;
                  pDetails.lineBlue = lineStyle.b;
                  let fillStyle = rgbaStringConvert(m.fill.color_);
                  if (fillStyle.a === 0) { pDetails.showFill = false; } else { pDetails.showFill = true; }
                  pDetails.fillOpacity = fillStyle.a;
                  pDetails.fillRed = fillStyle.r;
                  pDetails.fillGreen = fillStyle.g;
                  pDetails.fillBlue = fillStyle.b;
                  let points = [];
                  let coords = m.coordinates.toString().split(',');
                  for(let p = 0 ; p < coords.length; p+=2) {
                    let coodv = {};
                    coodv.x = coords[p];
                    coodv.y = coords[p+1];
                    points.push(coodv);
                  }
                  pDetails.points = points;
                  a.polygon = pDetails;
                  mapMarkups.push(a);
                }

                if (m.type === 'text'){
                  //{"type":"text","fill":{"color_":"rgba(244,67,54,0)"},"stroke":{"color_":"rgb(244,67,54)","lineDash_":null,"width_":3},"text":{"font_":"12px Arial","scaleArray_":[1,1],"text_":"My text to add","fill_":{"color_":"#333"},"maxAngle_":0.7853981633974483,"placement_":"point","overflow_":false,"stroke_":null,"offsetX_":0,"offsetY_":0,"backgroundFill_":null,"backgroundStroke_":null,"padding_":null},"extent":[525584.6242675781,168224.19299316406,525584.6242675781,168224.19299316406]}
                  let pDetails = {};
                  pDetails.text = m.text.text_;
                  let coords = m.extent.toString().split(',');
                  pDetails.x = coords[0];
                  pDetails.y = coords[1];
                  pDetails.width = coords[2] - coords[0];
                  pDetails.height = coords[3] - coords[1];

                  let fontfill = m.fill.color_;
                  fontfill = fontfill.replace('rgba(', '');
                  fontfill = fontfill.replace(')', '');
                  let afontfill = fontfill.split(',');
                  pDetails.fillRed = afontfill[0];
                  pDetails.fillGreen = afontfill[1];
                  pDetails.fillBlue = afontfill[2];
                  pDetails.fillOpacity = afontfill[3];
                  pDetails.showFill = true;

                  pDetails.lineWidth = parseFloat(m.stroke.width_);

                  let font = m.text.font_.split(' ');
                  let fontSize = font[0].replace('px', '');

                  let fontStyle = {};
                  fontStyle.size = parseInt(fontSize);
                  fontStyle.family =font[1];
                  fontStyle.red = 0;
                  fontStyle.green = 0;
                  fontStyle.blue = 0;
                  pDetails.font = fontStyle;
                  //"font": {"family": "Arial","style": "","size": 6,"red": 0,"green": 0,"blue": 0}

                  a.text = pDetails;
                  mapMarkups.push(a);
                }


              }
              template.templatePage.items[i].map.annotations = mapMarkups;
            }
            /*
            "annotations":[

              {"polygon":{"showLine":true,"fillOpacity":0.9,"lineWidth":0.1,"lineRed":255,"lineGreen":0,"lineBlue":0,"showFill":false,"fillRed":0,"fillGreen":0,"fillBlue":255,"points":[{"x":320650,"y":612000},{"x":321500,"y":611400},{"x":321200,"y":611200},{"x":320700,"y":611900},{"x":320750,"y":611600}]}},
              {"circle":{"showLine":true,"fillOpacity":0.9,"lineWidth":0.1,"lineRed":0,"lineGreen":255,"lineBlue":0,"showFill":false,"fillRed":255,"fillGreen":255,"fillBlue":0,"x":322663.9583, "y":612284.4166,"radius":100}},
              {"polyline":{"showLine":true,"fillOpacity":0.9,"lineWidth":0.1,"lineRed":0,"lineGreen":0,"lineBlue":255,"showFill":false,"fillRed":0,"fillGreen":255,"fillBlue":0,"points":[{"x":320722,"y":611654},{"x":320900,"y":611550},{"x":321121,"y":611500},{"x":321321,"y":611490},{"x":321151,"y":611660}]}},
              {"text":{"text":"Map position", "x":321822,"y":612254, "width": 30, "height":20 ,"showLine":true,"fillOpacity":0.9,"lineWidth":0.1,"lineRed":0,"lineGreen":0,"lineBlue":255,"showFill":false,"fillRed":0,"fillGreen":255,"fillBlue":0,"font": {"family": "Arial","style": "","size": 6,"red": 0,"green": 0,"blue": 0}}}
            ]*/

            break;
          case "image":
            switch (template.templatePage.items[i].image.id){
              case "findLogo":
              case "findlogo":
              case "find_logo":
                template.templatePage.items[i].image.name = process.env.REACT_APP_PRINT_FINDLOGO;
                break;
              case "client_logo":
              case "clientlogo":
              case "clientLogo":
                template.templatePage.items[i].image.name = uState.default.dprintlogo;
                break;
              case "north_arrow":
              case "northarrow":
              case "northArrow":
                template.templatePage.items[i].image.name = process.env.REACT_APP_PRINT_NORTHARROW;
                break;
              case "os_logo":
              case "oslogo":
              case "osLogo":
                template.templatePage.items[i].image.name = process.env.REACT_APP_PRINT_OSLOGO
                break;
              default:
                template.templatePage.items[i].image.name = template.templatePage.items[i].image.id+'.png';
                break;
            }

            break;

          case "cell":

            switch (template.templatePage.items[i].cell.id){
              case "scale":
                template.templatePage.items[i].cell.text = "1: "+sState.print.scale;
                break;
              case "mapTitle":
                template.templatePage.items[i].cell.text = sState.print.title;
                break;
              case "Additional Information":
              case "mapDescription":
                template.templatePage.items[i].cell.text = sState.print.description;
                break;
              case "SuppliedBy":
                template.templatePage.items[i].cell.text = process.env.REACT_APP_SUPPLIEDBY;
                break;
              case "date":
                let date = new Date();
                const day= ('0'+date.getDate()).slice(-2);
                const month = ('0'+(date.getMonth()+ 1)).slice(-2);
                template.templatePage.items[i].cell.text = day+'/'+ month +'/'+date.getFullYear();
                break;
              case "orderId":
                template.templatePage.items[i].cell.text = "$(orderid)";
                break;
              case "CentreCoords":
                const cx = parseFloat(ext[0]) + parseFloat((parseFloat(ext[2]) - parseFloat(ext[0]))/2);
                const cy = parseFloat(ext[1]) + parseFloat((parseFloat(ext[3]) - parseFloat(ext[1]))/2);
                template.templatePage.items[i].cell.text = cx.toFixed(0)+","+cy.toFixed(0);
                break;
              case "DownloadName":
                template.templatePage.items[i].cell.text = "";
                break;
              case "ProjectRef":
              case "projectRef":
                template.templatePage.items[i].cell.text = sState.projectreference;
                break;
              case "copyright":
              case "Copyright":
                template.templatePage.items[i].cell.text = process.env.REACT_APP_PRINT_COPYRIGHT.replaceAll("dddd", new Date().getFullYear());
                break;
              case "bgscopyright":
                template.templatePage.items[i].cell.text = process.env.REACT_APP_PRINT_BGS_COPYRIGHT.replaceAll("dddd", new Date().getFullYear());
                break;
              default:
                //console.log("Template default cell items:"+template.templatePage.items[i].cell.id);
                break;
            }
            break;
          default:
            break;
        }
      }
    } else {
      console.log("Template not found!");
    }
    return template;
  };

  const rgbStringConvert = (rgb) => {

    rgb = rgb.replace('rgb(', '');
    rgb = rgb.replace(')', '');
    const rgb_parts = rgb.split(',');
    const v = {};
    v.r = parseInt(rgb_parts[0]);
    v.g = parseInt(rgb_parts[1]);
    v.b = parseInt(rgb_parts[2]);
    return v;
  }

  const rgbaStringConvert = (rgba) => {

    rgba = rgba.replace('rgba(', '');
    rgba = rgba.replace(')', '');
    const rgba_parts = rgba.split(',');
    const v = {};
    v.r = parseInt(rgba_parts[0]);
    v.g = parseInt(rgba_parts[1]);
    v.b = parseInt(rgba_parts[2]);
    v.a = parseFloat(rgba_parts[3]);
    return v;
  }

  /**
   * Tracks the response from the order request.
   * Gets the current orderid.
   */
  useEffect(() => {
    if (parseInt(sState.orderid) !== -1 && parseInt(sState.orderid) !== 0){
      setOrderID(sState.orderid);
      setOrderStatus("ordered");
    }
  },[sState.orderid])

  /**
   * Manages the monitoring
   */
  useEffect(() => {
    switch(orderStatus){
      case "ordered":
      case "processing":
        if (!doPoll){ setDoPoll(true); }
        if (!isProcess){ setIsProcess(true); }
        setHasDownload(true);
        setDownloaddisabled(true);
        break;
      case "completed":
        if (doPoll){ setDoPoll(false); window.clearInterval(pollTimer);}
        if (isProcess){ setIsProcess(false); }
        break;
      default:
        break;
    }
  },[orderStatus])

  /**
   * Activates the order poll after order has been placed/
   */
  useEffect(() => {
    if (doPoll){
      pollOrderStatus();
    }
  },[doPoll])

  /**
   * Polls for order status.
   **/
  const pollOrderStatus = () => {
    let counter = 0;
    let timer = window.setInterval(function(){
      pollRequest();
      if (counter >= 60) { clearInterval(timer); sethasDownloadError(true); }
      counter++;
    }, 10000);
    setPollTimer(timer);

    const pollRequest = () => {
      const abortController = new AbortController();
      const request = {
        userid:sState.userid,
        orderid:orderID,
        sessionid:sState.ident,
      };

      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/order/status', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        });
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            if (data.orderStatus !== orderStatus){
              setOrderStatus(data.orderStatus);
            }
          }
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
      })();
    };
  };

  /**
   * Requests the download.
   */
  const handleFileDownload = (event) => {

      if (uState.company.companytype == 'training'){
        downloadSample(sampleProduct);
      } else {
        downloadOrder(orderID, sState.ident, sState.userid);
        sDispatch({ type: "setUserAction", payload: { action: "endprint" } });
        setIsProcess(false);
        setDownloaddisabled(true);
      }
  }

  const handleCloseDownload = () =>{
        setDoPoll(false); window.clearInterval(pollTimer);
        sDispatch({ type: "setUserAction", payload: { action: "endprint" } });
        setIsProcess(false);
        setDownloaddisabled(true);
  }

  const handleProjectReferenceChange = (e) => {
    const newProjectReference = e.target.value;
    if (allowedPattern.test(newProjectReference)) {
      setProjectReference(newProjectReference);
    }
  };

  const handlePONumberChange = (e) => {
    const newPONumber = e.target.value;
    if (allowedPattern.test(newPONumber)) {
      setPoNumber(newPONumber);
    }
  };

  return (
      <div className={classes.root}>
        <Accordion expanded={hasPrint} onChange={e => setHasPrint(!hasPrint)}>
          <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
          >
            <Typography className={classes.heading}>Print options</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="div" className={classes.container}>
              <TextField id="printLayerOptions" label="Map background" value={printlayer} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.textField} onChange={e => setPrintlayer(e.target.value)} select >
                <MenuItem value={'osmmbw'}>OS Plan Black / White</MenuItem>
                <MenuItem value={'osmm'}>OS Mastermap Colour</MenuItem>
                <MenuItem value={'os10k'}>OS OML (1:10,000)</MenuItem>
                <MenuItem value={'osvml'}>OS VML (1:10,000)</MenuItem>
                <MenuItem value={'os25k'}>OS VMD (1:25,000)</MenuItem>
                <MenuItem value={'os50k'}>1:50,000</MenuItem>
                <MenuItem value={'os250k'}>1:250,000</MenuItem>
                <MenuItem value={'aerial'}>Imagery</MenuItem>
              </TextField>
              <TextField id="printLayerOptions" label="Template" value={papersize} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.textField} onChange={e => setPapersize(e.target.value)} select >
                {papersizeitems.map((item, i) =>
                    <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                )}
              </TextField>

              <TextField id="printLayerOptions" label="Scale" value={scale} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.textField} onChange={e => handleScaleChange(e.target.value)} select >
                {scaleitems.map((item, i) =>
                    <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                )}
              </TextField>
              {hasCustomScale ? (<TextField id="printCustomScale" error={hasScaleError} label="Custom Scale" value={customscale} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}, startAdornment: <InputAdornment position="start"><Box fontSize={12}>1:</Box></InputAdornment>}} className={classes.textField} onChange={handleCustomScaleChange}></TextField>) : ( '' ) }
              {hasScaleError ? ( <Box className={classes.errorTxt} fontSize={12}>{scaleErrorText}</Box>) : ( '' )}

              <TextField id="printLayerOptions" label="Format" value={format} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.textField} onChange={e => setFormat(e.target.value)} select >
                {outputitems.map((item, i) =>
                    <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                )}
              </TextField>
              <TextField id="printLayerOptions" label="Orientation" value={orientation} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.textField} onChange={e => setOrientation(e.target.value)} select >
                {layoutitems.map((item, i) =>
                    <MenuItem key={i} value={item.value}>{item.label}</MenuItem>
                )}
              </TextField>
              <Box display="flex" flexWrap="nowrap">
                <Checkbox id="printgridOptions" checked={hasgrid} size="small" onChange={e => setHasgrid(!hasgrid)} inputProps={{ 'aria-label': 'checkbox with small size' } }></Checkbox><Box className={classes.textgridField} fontSize={12}>Add gridlines</Box>
                <Box className={classes.printAreaLabel} fontSize={12}>Area: {printArea}</Box>
              </Box>
              <Divider />
              <Grid container className={classes.priceTable}>
                <Grid item xs={3}><Box className={classes.priceLabel} fontSize={11}>Print Title</Box></Grid>
                <Grid item xs={9}><TextField id="print_title" value={title} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.projectRefText} onChange={e => setTitle(e.target.value)} ></TextField></Grid>
                <Grid item xs={3}><Box className={classes.priceLabel} fontSize={11}>Description</Box></Grid>
                <Grid item xs={9}><TextField id="print_description" value={description} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.poText} onChange={e => setDescription(e.target.value)}></TextField></Grid>
              </Grid>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={hasCheckout} onChange={e => setHasCheckout(!hasCheckout)}>
          <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1b-content"
              id="panel1b-header"
          >
            <Typography className={classes.heading}>Checkout</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="div" className={classes.container}>
              <Grid container className={classes.priceTable}>
                <Grid item xs={3}><Box className={classes.priceLabel} fontSize={11}>Project Reference</Box></Grid>
                <Grid item xs={9}><TextField id="project_reference" error={hasPRError} value={projectReference} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.projectRefText} onChange={handleProjectReferenceChange} required></TextField></Grid>
                <Grid item xs={3}><Box className={classes.priceLabel} fontSize={11}>PO Number</Box></Grid>
                <Grid item xs={9}><TextField id="ponumber" value={poNumber} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.poText} onChange={handlePONumberChange}></TextField></Grid>
                { hasPRError ? (<Grid item xs={12}><Box className={classes.errorTxt} fontSize={11}>Project Reference is required</Box></Grid>) : ( '' )}
                { hasPriceError ? (<Grid item xs={12}><Box className={classes.errorTxt} fontSize={11}>{hasPriceErrorMsg}</Box></Grid>) : ( '' )}
              </Grid>
              <Divider />
              <Grid container className={classes.priceTable}>
                <Grid item xs={8}><Box className={classes.priceLabel} fontSize={12}>Price:</Box></Grid>
                <Grid item xs={1}><Box className={classes.priceLabel} fontSize={12}>£</Box></Grid>
                <Grid item xs={3}><Box className={classes.priceLabel} alignItems="right" fontSize={12}>{price}</Box></Grid>
                <Grid item xs={8}><Box className={classes.priceLabel} fontSize={12}>VAT:</Box></Grid>
                <Grid item xs={1}><Box className={classes.priceLabel} fontSize={12}>£</Box></Grid>
                <Grid item xs={3}><Box className={classes.priceLabel} alignItems="right" fontSize={12}>{vat}</Box></Grid>
                <Grid item xs={8}><Box className={classes.priceLabel} fontWeight="fontWeightBold" fontSize={12}>Total:</Box></Grid>
                <Grid item xs={1}><Box className={classes.priceLabel} fontWeight="fontWeightBold" fontSize={12}>£</Box></Grid>
                <Grid item xs={3}><Box className={classes.priceLabel} fontWeight="fontWeightBold" alignItems="right" fontSize={12}>{total}</Box></Grid>
              </Grid>
              <Divider />
              <Box className={classes.priceLabel} fontSize={12}>By clicking 'Purchase' you are agreeing to our <a href='https://www.mapdata.uk/terms' target='_blank' rel='noopener noreferrer' aria-label="Mapdata.uk terms and conditions">Terms and conditions</a></Box>
              <HtmlTooltip title={<React.Fragment>{purchaseTooltip}</React.Fragment>}>
                <span><Button className={classes.purchaseButton} disabled={lockPurchase} onClick={handlePurchase}>
                  <Box p={1} fontWeight="fontWeightBold" fontSize={12}>Purchase</Box>
                </Button></span>
              </HtmlTooltip>
              <Button className={classes.cancelButton} onClick={cancelPurchase}>
                <Box fontWeight="fontWeightBold" fontSize={12}>Cancel</Box>
              </Button>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion disabled={downloaddisabled} expanded={hasDownload} onChange={e => setHasDownload(!hasDownload)}>
          <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
          >
            <Typography className={classes.heading}>Download</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {isProcess ? (
                <Button className={classes.downloadButton} variant="contained" disabled>
                  <Box p={1} display="flex" ><ReactLoading className={classes.loadingImg} type={'spin'} color={'#F6A036'} height={16} width={16}/></Box><Box p={1} fontWeight="fontWeightBold" fontSize={12}>Processing</Box>
                </Button>
            ) : (
                <Button className={classes.downloadButton} variant="contained" onClick={handleFileDownload} >
                  <Box p={1} display="flex" ><GetAppIcon className={classes.downloadIcon} /></Box><Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Download</Box>
                </Button>
            )}
            <Button className={classes.closeMenuButton} variant="contained" onClick={handleCloseDownload} >
                <Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Close</Box>
            </Button>
            <Box className={classes.priceLabel} fontSize={16}>
              {hasDownloadError && (
                <Typography color="error">
                  Something is not right with your download. Please contact support on support@mapdata.uk and let us know.
                </Typography>
              )}
            </Box>
          </AccordionDetails>
        </Accordion>
      </div>
  );
}